import React from 'react';
import { useScreenInit } from '../useScreenInit';
import { Header } from './Header';
import { HeroSystem } from './HeroSystem';
import { OfferLearning } from './OfferLearning';
import { RecipesAccess } from './RecipesAccess';
import { TrustFooter } from './TrustFooter';
export function LandingPage() {
  useScreenInit();
  return <div className="min-h-screen w-full overflow-hidden bg-[#fcfbf7] text-[#344833]" data-id="element-164">
      <Header data-id="element-165" />
      <main data-id="element-166">
        <HeroSystem data-id="element-167" />
        <OfferLearning data-id="element-168" />
        <RecipesAccess data-id="element-169" />
        <TrustFooter data-id="element-170" />
      </main>
    </div>;
}